function applyPriceFilter() {

    const min = document.getElementById("brc-min-price").value;
    const max = document.getElementById("brc-max-price").value;

    const url = new URL(window.location.href);

    if (min)
        url.searchParams.set("filter.v.price.gte", min);
    else
        url.searchParams.delete("filter.v.price.gte");

    if (max)
        url.searchParams.set("filter.v.price.lte", max);
    else
        url.searchParams.delete("filter.v.price.lte");

    const facets = document.querySelector('[data-ntajax-container]').Facets;

    if (!facets) {
        window.location = url.toString();
        return;
    }

    facets.ntAjaxStart();

    facets.loadPageContent(url.toString());

    facets.updateURLHash(
        $('<a href="' + url.toString() + '"></a>'),
        true,
        url.toString()
    );

}

document.addEventListener("click", function(e){

    // Apply button
    if(e.target.id === "brc-price-apply"){
        applyPriceFilter();
        return;
    }

    // Price chips
    const chip = e.target.closest(".brc-price-chip");

    if(chip){

        e.preventDefault();

        document.getElementById("brc-min-price").value = chip.dataset.min;
        document.getElementById("brc-max-price").value = chip.dataset.max;

        applyPriceFilter();
    }

});

document.addEventListener("keydown", function(e){

    if(
        e.key === "Enter" &&
        (e.target.id === "brc-min-price" || e.target.id === "brc-max-price")
    ){
        e.preventDefault();
        applyPriceFilter();
    }

});
document.addEventListener("click", function(e){

    let button = e.target.closest("#brc-price-apply");

    if(!button) return;

    e.preventDefault();

    let wrapper = button.closest(".brc-price-filter");

    let min = parseFloat(
        wrapper.querySelector("#brc-min-price").value || 0
    ) * 100;

    let max = parseFloat(
        wrapper.querySelector("#brc-max-price").value || 999999
    ) * 100;


    document.querySelectorAll(".t4s-product").forEach(function(product){

        let price = parseInt(product.dataset.minPrice);

        if(price >= min && price <= max){
            product.style.display = "";
        } else {
            product.style.display = "none";
        }

    });

});